import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions';
import { INBOX_TYPES } from 'dashboard/helper/inbox';
import { getUserPermissions } from 'dashboard/helper/permissionsHelper';
import wootConstants from 'dashboard/constants/globals';

// Channels handled like email: messages arrive without the urgency of a live
// chat, so they must not trigger an audio alert on every message.
const SILENT_CHANNEL_TYPES = [
  INBOX_TYPES.EMAIL,
  INBOX_TYPES.PHONE,
  INBOX_TYPES.ALLEGRO,
  INBOX_TYPES.KAUFLAND,
];

class AudioNotificationStore {
  constructor(store) {
    this.store = store;
  }

  isUserOnCall = () => {
    const phoneStatus = this.store.getters['phone/getStatus'];
    return ['ringing', 'dialing', 'speaking'].includes(phoneStatus);
  };

  hasUnreadConversation = () => {
    const mineConversation = this.store.getters.getMineChats({
      assigneeType: 'me',
      status: 'open',
    });

    return mineConversation.some(conv => conv.unread_count > 0);
  };

  isMessageFromPendingConversation = (message = {}) => {
    const { conversation_id: conversationId } = message || {};
    if (!conversationId) return false;

    const activeConversation =
      this.store.getters.getConversationById(conversationId);
    return activeConversation?.status === wootConstants.STATUS_TYPE.PENDING;
  };

  isMessageFromCurrentConversation = message => {
    return this.store.getters.getSelectedChat?.id === message.conversation_id;
  };

  hasConversationPermission = user => {
    const currentAccountId = this.store.getters.getCurrentAccountId;
    // Get the user permissions for the current account
    const userPermissions = getUserPermissions(user, currentAccountId);
    // Check if the user has the required permissions
    const hasRequiredPermission = [...ROLES, ...CONVERSATION_PERMISSIONS].some(
      permission => userPermissions.includes(permission)
    );
    return hasRequiredPermission;
  };

  isSilentChannelMessage = message => {
    const inboxId = message.inbox_id;
    const inbox = this.store.getters['inboxes/getInbox'](inboxId);
    const channelType = inbox?.channel_type;
    return SILENT_CHANNEL_TYPES.includes(channelType);
  };
}

export default AudioNotificationStore;
